<script>
import {defineComponent, computed} from "vue";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";

import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default defineComponent({
  components: {DataTable, Column},
  props: {
    tariffs: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const {t} = useI18n();
    const store = useStore();
    const lang = computed(() => store.getters.getLang);
    const nameField = computed(() => `name_${lang.value}`);

    return {t, nameField};
  }
});
</script>

<template>
  <DataTable :value="tariffs ?? []" showGridlines tableStyle="min-width: 50rem" selectionMode="single">
    <Column field="id" header="ID"></Column>
    <Column :field="nameField" :header="t('tables.tariffs.name')" >
      <template #body="slotProps">
        <router-link
            class="color-black-80 color-primary-hover"
            :to="{ name: 'tariff-view', params: {id: slotProps.data.id}}"
        >
          {{ slotProps.data[nameField] }}
        </router-link>
      </template>
    </Column>
  </DataTable>
</template>